module.exports = __webpack_public_path__ + "img/소드맨.aa549780.png";